<template>
    <div class="pb4 bb b--light-gray">
        <LabeledValue class="mb3" heading="Item">Bostitch 3.5-in Cordless Framing Nailer</LabeledValue>
        <LabeledValue class="mb3" heading="From">Jun 25, 2018 at 7:00am</LabeledValue>
        <LabeledValue class="mb3" heading="To">Jun 29, 2018 at 10:00PM</LabeledValue>
    </div>
</template>

<script>
import LabeledValue from '@/components/controls/LabeledValue.vue';

export default {
    components: {
        LabeledValue
    }
};
</script>
